import { forwardRef } from 'react';

import { useBoundStore } from 'app/store';

import { ERROR_MESSAGE } from '../config';

export const FormInput = forwardRef(({ invalid, ...props }, ref) => {
  const firstSubmitForm = useBoundStore((state) => state.hsptlzForm.firstSubmitForm);
  const error = !firstSubmitForm && invalid !== undefined && invalid;

  return (
    <>
      {/* error 처리 - data 속성 */}
      <input {...props} data-error={error} ref={ref} />

      {error && (
        <div className='contact-item-error-msg'>
          <span>{ERROR_MESSAGE[props.name]}</span>
        </div>
      )}
    </>
  );
});

FormInput.displayName = 'FormInput';
